import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { customAreaCountryCodes } from '@components-shared/forms/PhoneInput';
import cn from 'classnames';
import 'styles/shared/phoneInput.scss';
import { CONSTANTS } from '../constants';
import { EventTarget } from './types';

interface IProps {
  onChange: (e: EventTarget) => void;
  className: string;
  name: string;
  required: boolean;
  value: string;
  preferredCountries: string[];
  defaultCountry?: string;
  disabled: boolean;
}

const PhoneInputConstructorFormComponent: React.FC<IProps> = ({
  name,
  value,
  preferredCountries,
  defaultCountry,
  onChange,
  required,
  disabled,
}) => {
  const onPhoneInputChange = (value: string) => {
    const e = { target: { name, value } };

    onChange(e);
  };

  return (
    <PhoneInput
      country={defaultCountry}
      preferredCountries={preferredCountries}
      areaCodes={customAreaCountryCodes}
      countryCodeEditable={false}
      specialLabel=""
      onChange={(val) => onPhoneInputChange(val)}
      inputClass="cc-input"
      containerClass={cn({ disabled })}
      disabled={disabled}
      value={value || ''}
      inputProps={{ name, required }}
      enableLongNumbers={CONSTANTS.PHONE_LENGTH}
    />
  );
};

export default PhoneInputConstructorFormComponent;
